import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#f3f3f1] flex items-center justify-center p-6">
      <div data-testid="payment-cancel-card" className="w-full max-w-md bg-white rounded-2xl p-8 shadow-sm text-center">
        <h1 className="font-display text-2xl mb-2">Betaling geannuleerd</h1>
        <p className="text-sm text-gray-500 mb-6">Geen zorgen — er is niets afgeschreven.</p>
        <Link to="/"><Button className="rounded-full bg-[#1a1a1a] text-white hover:bg-black/90">Terug naar dashboard</Button></Link>
      </div>
    </div>
  );
}
